import { z } from 'zod';

import { ContentfulSysSchema } from './contentful-sys.validator';
import { LabelIconPairEntrySchema } from './label-icon-pair.validator';
import { SustainabilityGroupEntrySchema } from './sustainability-group.validator';

export const SustainabilitySubgroupEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    name: z.string(),
    sustainabilityGroup: SustainabilityGroupEntrySchema.optional().nullable(),
    labelIconPair: LabelIconPairEntrySchema.optional().nullable()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});
